import BBDO_Streetwiz from '../modules/streetwiz'

export default class BBDO_Form {

	constructor($el, $submitHandler) {
		this.$el = $el;
		this.$submitHandler = $submitHandler;
		this.init_events();
		this.messages = window.site.validation;
		this.messages = $.parseHTML(this.messages);
		this.messages = jQuery.parseJSON(this.messages[0].textContent);
	}

	check_data_amount(container, submit) {
		const amount = container.attr('data-amount');
		if ((amount !== "") && ((container.find('input[type="checkbox"]:checked').length > amount) || (container.find('input[type="checkbox"]:checked').length < amount))) {

			let message;
			if (container.find('input[type="checkbox"]:checked').length > amount) {
				message = window.site.validation.game.amount_tomuch;
			} else {
				message = window.site.validation.game.amount_less;
			}
			message = message.replace(':value', amount);
			container.find('.error-message').html(message);
			container.find('.input').addClass('error');
			return false;
		} else {
			container.find('.error-message').html('');
			container.find('.input').removeClass('error');
			return true;
		}
	}

	validate_email(email) {
		const pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
		return pattern.test(email);
	}

	checkStrength(password, $result) {
		//initial strength
		let strength = 0;
		//if the password length is less than 6, return message.
		if (password.length < 8) {
			$result.removeClass();
			$result.addClass('short');
			$result.html(window.site.password[0]);
			return;
		}

		//if length is 8 characters or more, increase strength value
		if (password.length >= 8) {
			strength += 1;
		}

		//if password contains both lower and uppercase characters, increase strength value
		if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
			strength += 1;
		}

		//if it has numbers and characters, increase strength value
		if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/)) {
			strength += 1;
		}

		//if it has one special character, increase strength value
		if (password.match(/([~`!#@$%\^&*+=\-\[\]\\';,\/{}|\\":<>\?])/)) {
			strength += 1;
		}

		if (strength < 2) {
			$result.removeClass();
			$result.addClass('weak');
			$result.html(window.site.password[1]);
			return;
		} else if (strength === 2) {
			$result.removeClass();
			$result.addClass('medium');
			$result.html(window.site.password[2]);
			return;
		} else if (strength === 3) {
			$result.removeClass();
			$result.addClass('medium');
			$result.html(window.site.password[2]);
			return;
		} else {
			$result.removeClass();
			$result.addClass('strong');
			$result.html(window.site.password[4]);
			return;
		}
	}

	validate_input($el) {
		let integer;
		let { required } = this.messages;
		required = required.replace(':attribute', ($el.attr('placeholder')).toLowerCase());

		if ($el.val() === "") {
			if ($el.attr('type') === "number") {
				({ integer } = this.messages);
				$el.next('.error-message').html(integer);
				return $el.addClass('error');
			} else {
				$el.addClass('error');
				return $el.next('.error-message').html(required);
			}
		} else {
			let error, password;
			$el.removeClass('error');
			switch ($el.attr('type')) {
				case 'number':
					if (isNaN(parseFloat($el.val())) && !isFinite($el.val())) {
						({ integer } = this.messages);
						$el.next('.error-message').html(integer);
						return $el.addClass('error');
					}
					break;
				case 'email':
					if (!this.validate_email($el.val())) {
						let { email } = this.messages;
						email = email.replace(':attribute', $el.attr('name'));
						$el.next('.error-message').html(email);
						return $el.addClass('error');
					}
					break;
				case 'password':
					if ($el.attr('name') === "password_double") {
						password = $el.closest('form').find('input[type="password"]:not(.js-no-password-validation)').val();
						if ($el.val() !== password) {
							$el.addClass('error');
							error = this.messages.password.same;
							return $el.next('.error-message').html(error);
						} else {
							return $el.removeClass('error');
						}
					} else {
						password = $el.val();
						if (!$el.hasClass('js-no-password-validation')) {
							if (password.length < 6) {
								$el.addClass('error');
								error = this.messages.password.min;
								return $el.next('.error-message').html(error);
							} else if (!password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/) || !password.match(/([0-9])/)) {
								$el.addClass('error ');
								error = this.messages.password.regex;
								return $el.next('.error-message').html(error);
							} else {
								return $el.removeClass('error');
							}
						}
					}
					break;
			}
		}
	}

	init_events() {
		let self = this;

		if (this.$el.find('input[name=zipcode]')[0]) {
			new BBDO_Streetwiz(this.$el.find('input[name=zipcode]'), this.$el.find('input[name=city]'), this.$el.find('input[name=street]'));
		}

		this.$el.find('.js-check-strength').on('keyup', function (e) {
			return self.checkStrength($(this).val(), $(this).parent().find('#strength-result'));
		});

		this.$el.on('blur', 'input[required], textarea[required]', function (e) {
			return self.validate_input($(this));
		});

		this.$el.find('[data-amount] input[type="checkbox"]').on('change', function (e) {
			const container = $(this).parent().parent();
			return self.check_data_amount(container, false);
		});

		return this.$el.on('submit', e => {
			e.preventDefault();
			const $form = $(e.target);

			let self = this;

			const options = {
				url: $form.prop('action'),
				type: "POST",
				dataType: "json",
				beforeSubmit: (arr, $form, options) => {
					let submit = true;
					$form.find('[data-amount]').each(function () {
						const container = $(this);
						submit = this.check_data_amount($form.find(container), true);
					});

					if ($form.find('input[type=number]')[0]) {
						const $el = $form.find('input[type=number]');
						if ((isNaN(parseFloat($el.val())) && !isFinite($el.val())) || ($el.val() === "")) {
							const { integer } = this.messages;
							$el.next('.error-message').html(integer);
							$el.addClass('error');
							submit = false;
						}
					}

					return submit;
				},

				headers: { 'X-CSRF-TOKEN': $('input[name="_token"]').val() },
				success: (data, statusText, xhr) => {
					//reset validation
					$('input', $form).removeClass('error').next('.error-message').html('');
					$('input', $form).parent().removeClass('error').find('.error-message').html('');

					if (data.data === 'INPUTERROR') {
						$.each(data.errors, function (key, value) {
							if ($(`input[name="${key}"]`, $form)[0]) {
								$(`input[name="${key}"]`, $form).addClass('error').next('.error-message').html(value[0]);

								if (($(`input[name="${key}"]`, $form).attr('type') === "checkbox") || ($(`input[name="${key}"]`, this.$el).attr('type') === "radio")) {
									return $(`input[name="${key}"]`, $form).parent().addClass('error').find('.error-message').html(value[0]);
								}

							} else if ($(`textarea[name="${key}"]`, $form)[0]) {
								return $(`textarea[name="${key}"]`, $form).addClass('error').next('.error-message').html(value[0]);
							} else if ($(`select[name="${key}"]`, $form)[0]) {
								return $(`select[name="${key}"]`, $form).parent().parent().addClass('error').find('.error-message').html(value[0]);
							}
						});
						$('html, body').animate({ scrollTop: $(".error").first().offset().top - $('.nav').outerHeight() - 20 }, 100);
					}

					if (data.data === 'OK') {
						if (data.payload) {
							$.each(data.payload, function (key, value) {
								console.log(key, value);
								return $(`input[type="hidden"][name="${key}"]`).val(value);
							});
						}
						if (data.notification) {
							$('body').prepend(data.notification);

							if ($('.notification:not(.dont_autoclose)')[0]) {
								setTimeout((() =>
									$('.notification').slideUp(function () {
										return $(this).remove();
									})
								), window.site.notification_time);
							}

							if (this.$submitHandler) {
								return this.$submitHandler(this.$el);
							}
						} else {
							return window.location = data.redirect;
						}
					}
				}
			};

			return $form.ajaxSubmit(options);
		});
	}

}
